


































































import Vue from 'vue';

export default Vue.extend({
  name: 'NewsItem',
  props: {
    newsitem: Object
  },
  data() {
    return {
      item: this.newsitem,
    }
  }
});
